<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body">
      <header class="text-center pb-4">
        <h3
          class="my-0 text-2xl font-bold"
          v-text="'Update Payment Method'"
        />
      </header>
      <section class="mx-6">
        <div class="field sm:w-full">
          <div class="field__label flex items-center justify-between">
            <label
              for="payment_method_name"
              v-text="'Name On Card'"
            />
            <ErrorMessage :error="form.errors.get('fullName')" />
          </div>
          <input
            id="payment_method_name"
            v-model="form.fullName"
            :class="{ 'error': form.errors.has('fullName') }"
            placeholder="Jane Doe"
            type="text"
            name="payment_method_name"
          >
          <div class="field__label flex items-center justify-between">
            <label v-text="'Credit Card Information'" />
            <ErrorMessage :error="form.errors.get('creditCardInfo')" />
          </div>
          <div
            ref="card"
            class="sm:w-1/2"
          />
        </div>
      </section>
      <div class="modal-footer text-center mt-8">
        <button
          type="button"
          :class="{ 'load': processing }"
          :disabled="processing"
          :aria-disabled="processing"
          class="btn"
          @click="createPaymentMethod"
          v-text="'Update Payment Method'"
        />
        <button
          type="button"
          class="btn btn--sm btn--danger ml-4 "
          @click="close"
          v-text="'Cancel'"
        />
      </div>
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import { mapActions } from 'vuex'
import stripe from '../../mixins/stripeMixin'
import Form from 'Base/Resources/assets/js/plugins/Form'
import ErrorMessage from 'FormBuilder/Resources/assets/js/components/inputs/ErrorMessage'

export default {
  name: 'AddPaymentMethodModal',
  components: {
    ErrorMessage,
  },
  mixins: [stripe],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      cardElement: null,
      form: new Form({
        fullName: '',
      }),
      processing: false,
    }
  },
  mounted() {
    const elements = this.stripe.elements()
    const style = {
      classes: {
        base: 'field',
      },
    }

    this.cardElement = elements.create('card', style)
    this.cardElement.mount(this.$refs.card)

    this.paymentsGetPaymentMethods()
  },
  methods: {
    ...mapActions([
      'paymentsGetPaymentMethods',
      'paymentsAttachPaymentMethod',
    ]),
    close() {
      this.$emit('close')

      this.form.reset()

      this.cardElement.clear()
    },
    preValidateForm() {
      let hasErrors = false
      const validation = {
        errors: {},
      }

      if (!this.form.fullName) {
        validation.errors['fullName'] = ['This field is required']
        hasErrors = true
      }

      this.form.setErrors(validation)

      return hasErrors
    },
    createPaymentMethod() {
      if (!this.processing && !this.preValidateForm()) {
        this.processing = true

        this.$emit('processing')

        const vm = this

        this.stripe
          .createPaymentMethod({
            type: 'card',
            card: this.cardElement,
            billing_details: {
              name: this.form.fullName,
            },
          })
          .then(function (result) {
            if (result.paymentMethod) {
              vm.paymentsAttachPaymentMethod({
                payment_method: result.paymentMethod.id,
              }).then((result) => {
                vm.processing = false

                vm.$store.commit('baseAddNotification', {
                  type: 'success',
                  title: 'Success',
                  text: 'Payment Method Added!',
                })

                vm.paymentsGetPaymentMethods().then(()=>{
                  vm.close()
                })
              }).catch((errors) => {
                vm.form.setErrors(errors.response.data)

                vm.$store.commit('baseAddNotification', {
                  type: 'error',
                  title: 'Error',
                  text: (vm.form.errors.message),
                })

                vm.processing = false
              })
            }
            if (result.error) {
              vm.processing = false

              vm.$store.commit('baseAddNotification', {
                type: 'error',
                title: 'Error',
                text: result.error.message,
              })
            }
          })
      }
    },
  },
}
</script>

<style scoped>
.field {
  width: 100%;
  border-radius: .25rem;
  padding-left: .5rem;
  padding-right: .5rem;
  padding-top: .75rem;
  padding-bottom: .75rem;
  margin-bottom: 1.5rem;
  font-size: .875rem;
  border-width: 1px;
  border-color: #afb2b3
}
</style>
